import PayrollTypesView from '../PayrollTypesView.vue'
import PayrollTypeList from '../Pages/PayrollTypeList.vue'
import PayrollTypeEditor from '../Pages/PayrollTypeEditor.vue'

const routes = [
  {
    path: '/mantenimiento/tipos-planilla',
    component: PayrollTypesView,
    children: [
      { path: '', name: 'payroll-type-list', component: PayrollTypeList },
      { path: 'crear', name: 'payroll-type-create', component: PayrollTypeEditor },
      { path: ':id', name: 'payroll-type-edit', component: PayrollTypeEditor },
    ],
  },
]

export default routes
